import { RouteRecordRaw } from 'vue-router'

// 公共路由
export const publicRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: {
      title: 'CatParty - 首页',
      requiresAuth: false
    }
  },
  {
    path: '/store',
    name: 'Store',
    component: () => import('@/views/Store.vue'),
    meta: {
      title: 'CatParty - 商店',
      requiresAuth: false
    }
  },
  {
    path: '/ai-doctor',
    name: 'AiDoctor',
    component: () => import('@/views/AiDoctor.vue'),
    meta: {
      title: 'CatParty - AI医生',
      requiresAuth: false
    }
  },
  {
    path: '/community',
    name: 'Community',
    component: () => import('@/views/Community.vue'),
    meta: {
      title: 'CatParty - 社区',
      requiresAuth: false
    }
  }
]

// 不再需要私有路由
export const privateRoutes: RouteRecordRaw[] = []

// 404路由
export const notFoundRoute: RouteRecordRaw = {
  path: '/:pathMatch(.*)*',
  name: 'NotFound',
  component: () => import('@/views/NotFound.vue'),
  meta: {
    title: '页面不存在',
    requiresAuth: false
  }
}

// 合并所有路由
const routes: RouteRecordRaw[] = [...publicRoutes, ...privateRoutes, notFoundRoute]

export default routes
    